(function () {
    'use strict';

    angular.module("imApp").factory("deliveryCustomersService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1072,
                    parameters: parms || {}
                });
            },
            listDeliveryCustomers: function (parms) {
                return $ihttp.post({
                    method: 1073,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
